
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../shared/services/auth.service';
import { Injectable } from '@angular/core';
import { jwtDecode } from "jwt-decode";
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TOKEN_KEY } from '../contants/data-model';
import { Router } from '@angular/router';
import { UserModel } from '../models/user.model';
import { IClub } from '../models/club.model';
@Injectable({
    providedIn: 'root',
})
export class CoreService {
    pageLoader: boolean = true;
    decoded: any;
    isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
    isLoadObs$ = this.isLoading.asObservable();
    private isAuthenticated: boolean = false;
    private activeSection: 'main' | 'left' | 'right' = 'main';
    private myClubsSubject = new BehaviorSubject<IClub[]>([]);
    myClubs$ = this.myClubsSubject.asObservable();
    isMobileMenuActive: boolean = false;

    constructor(private authenticationService: AuthService, private http: HttpClient, private router: Router) {

     }

    public isLoggedIn(): boolean {
        this.isAuthenticated = this.authenticationService.getToken() ? true : false;
        return this.isAuthenticated;
    }

    public getUser(): UserModel {
        return this.authenticationService.getUser();
    }

    getHeader(): HttpHeaders {
        const tokenKey = localStorage.getItem(TOKEN_KEY)?.toString();
        return new HttpHeaders({
            'Authorization': 'Bearer ' + tokenKey,
            'Content-Type': 'application/json',
        });
    }

    checkEmailwithToken(emailaddress: string): boolean {
        var token = this.authenticationService.getToken();
        this.decoded = jwtDecode(token!);
        console.log(this.decoded.email);
        console.log(this.decoded.email == emailaddress);
        if (this.decoded.email == emailaddress) {
            console.log('Hello');
            return true;
        }
        else {
            return false;
        }
    }

    getApi(url: string): Observable<any> {
        const headers = this.getHeader();
        return this.http.get<any>(`${environment.myurl}${url}`, { headers });
    }

    getAnonymousApi(url: string, options: any): Observable<any> {
        return this.http.get<any>(`${environment.myurl}${url}`, options);   
    }

    postApi(url: string, payload: any,options?: any): Observable<any> {
        const headers = this.getHeader();
        const httpOptions = { headers, ...options };
        return this.http.post<any>(`${environment.myurl}${url}`, payload, httpOptions);
    }

    putApi(url: string, payload: any): Observable<any> {
        const headers = this.getHeader();
        return this.http.put<any>(`${environment.myurl}${url}`, payload, { headers });
    }

    deleteApi(url: string): Observable<any> {
        const headers = this.getHeader();
        return this.http.delete<any>(`${environment.myurl}${url}`, { headers });
    }

    navigateToPage(url: any): void {
        this.router.navigate(url);
    }
    setActiveSection(section: 'main' | 'left' | 'right') {
        this.activeSection = section;
      }
    
      getActiveSection(): 'main' | 'left' | 'right' {
        return this.activeSection;
      }
    
      setMyClubs(clubs: IClub[]) {
    this.myClubsSubject.next(clubs);
  }

  addClub(club: IClub) {
    const current = this.myClubsSubject.value;
    this.myClubsSubject.next([club, ...current]);
  }
 isBelow991(): boolean {
  return window.innerWidth < 992;
}

isTwoColumn(): boolean {
  return window.innerWidth >= 992 && window.innerWidth < 1200;
}

isThreeColumn(): boolean {
  return window.innerWidth >= 1200;
}

}